import { useEffect, useState } from 'react';
import { OrgNode } from '../../../services/orgs/interfaces';
import OrgsService from '../../../services/orgs';
import { extractErrorMessage } from '../../../util/errorMessage';
import usePropTimer from '../../../hooks/usePropTimer';
import { AWAIT_PROP_TIMEOUT_SECONDS } from '../../../const';

export default function usePayableOrg({
  payableOrgId,
  awaitPayableOrgId,
}: {
  payableOrgId?: string;
  awaitPayableOrgId: boolean;
}): {
  payableOrg?: OrgNode;
  errorMessage?: string;
  isFinished: boolean;
} {
  const [payableOrg, setPayableOrg] = useState<OrgNode>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [isFinished, setIsFinished] = useState(false);

  usePropTimer({
    onTimeout: () => {
      setErrorMessage(
        `Have not received payableOrgId after ${AWAIT_PROP_TIMEOUT_SECONDS}s`,
      );
      setIsFinished(true);
    },
    awaitProp: awaitPayableOrgId,
    propToAwait: payableOrgId,
  });

  useEffect(() => {
    const gatherData = async (): Promise<void> => {
      if (!!payableOrgId && payableOrg === undefined) {
        try {
          const retrievedPayableOrg =
            await OrgsService.getOrgNode(payableOrgId);
          setPayableOrg(retrievedPayableOrg);
        } catch (e) {
          setErrorMessage(extractErrorMessage(e));
        } finally {
          setIsFinished(true);
        }
      } else if (!payableOrgId && !awaitPayableOrgId) {
        setIsFinished(true);
      }
    };
    gatherData();
  }, [awaitPayableOrgId, payableOrg, payableOrgId]);
  return { payableOrg, errorMessage, isFinished };
}
